import React, {useEffect, useState} from "react";
import Input from "../theme/forms/Input";

const VoterLookupForm = ({element, onSubmit, onCancel, onDeleteElement}) => {
    const [formData, setFormData] = useState({paths:[], connectors:[], attribs:{}, ...element});

    function submit() {
        console.log("VoterLookup SUBMITTING ", formData)
        onSubmit(formData);
    }

    const handleChange = (field, value) => {
        const newForm = {...formData};
        const val = value === 'true' || value == true || value === 1 || value === '1' ? true : false
        if (field === 'check_prior_voter_selection' && val === false) {
            newForm.attribs.allow_selection_of_prior_selected_voter = false;
        }
        newForm.attribs[field] = val;
        setFormData(newForm);
    };

    const addPath = () => {
        setFormData({
            ...formData,
            paths: [...formData.paths],
        });
    };

    const removePath = (index) => {
        const updatedPaths = formData.paths.filter((_, i) => i !== index);
        setFormData({...formData, paths: updatedPaths});
    };

    return (
        <div className="sidebar-form">
            <h6 className={'m-0 pb-2'}>
                <i className="fa fa-random mr-3"></i>
                Add a VoterLookup
            </h6>

            <div className={'mb-4'}>
                <div className={'fieldWrapper'}>
                    <label>Name</label>
                    <input
                        className={'mb-4'}
                        type="text"
                        value={formData.display_name}
                        onChange={(e) => setFormData({...formData, display_name: e.target.value})}
                    />
                </div>
                <div className={'fieldWrapper'}>
                    <label>Prompt</label>
                    <input
                        className={'mb-4'}
                        type="text"
                        value={formData.prompt}
                        onChange={(e) => setFormData({...formData, prompt: e.target.value})}
                    />
                </div>
                <div className={'fieldWrapper'}>
                    <label>Check for Prior Selection</label>
                    <select
                        className={"mb-1"}
                        name={'check_prior_voter_selection'}
                        value={formData.attribs?.check_prior_voter_selection}
                        onChange={(e) => handleChange("check_prior_voter_selection", e.target.value)}
                    >
                        <option value={'true'}>Check if Selected</option>
                        <option value={'false'}>Don't bother</option>
                    </select>
                </div>
                <div className={'fieldWrapper'}>
                    <label>Allow Duplicates</label>
                    <select
                        className={"mb-1"}
                        name={'allow_selection_of_prior_selected_voter'}
                        disabled={formData.attribs?.check_prior_voter_selection !== true}
                        value={formData.attribs?.allow_selection_of_prior_selected_voter}
                        onChange={(e) => handleChange("allow_selection_of_prior_selected_voter", e.target.value)}
                    >
                        <option value={'true'}>Notify canvasser of prior selection</option>
                        <option value={'false'}>Do not allow any prior selection</option>
                    </select>
                </div>
            </div>

            <fieldset>
                {formData.paths?.map((path, index) => (
                    <div key={index} className="fieldWrapper">
                        <div className={'m-0 full-width flx space_between'}>
                            <label>Path {index + 1}</label>
                            {formData.paths.length > 1 && (
                                <i className="danger-text fas fa-minus-circle is-clickable mr-1"
                                   onClick={() => removePath(index)}>
                                </i>
                            )}
                        </div>
                    </div>
                ))}
            </fieldset>

            <div className={'button-wrapper'} style={{marginTop: 10}}>
                <button onClick={submit} className={'button'}>Submit</button>
                <button onClick={onCancel} className={'button button-outline'}>Cancel</button>
                <button onClick={onDeleteElement} className={'button danger'}>Delete</button>
            </div>

        </div>
    )
        ;
};

export default VoterLookupForm;
